import { Alert, Box, Button, Stack, Typography } from "@mui/material"
import { useRef } from "react"
import { Bound } from "lib/@components/binding/Bound"
import { If } from "lib/@components/if"
import { BoundTextEditor } from "minimals-template/components/editor"
import {
    getProjectBridgeLocalRewriteSaveLabel,
    getProjectBridgeSharedRewriteEditWarning,
    getProjectBridgeSharedRewriteSaveLabel,
} from "./project-bridge-rewrite-card-presenters"

export function ProjectBridgeRewriteEditor({ initialText, item, onSave, onCancel }) {
    const target = useRef({ text: initialText ?? "" }).current
    const warning = getProjectBridgeSharedRewriteEditWarning(item)
    const sharedSaveLabel = getProjectBridgeSharedRewriteSaveLabel(item)
    const localSaveLabel = getProjectBridgeLocalRewriteSaveLabel(item)

    return (
        <Stack spacing={0.5}>
            <Stack direction="row" alignItems="center" spacing={1} useFlexGap flexWrap="wrap" sx={{ minHeight: 28 }}>
                <Typography variant="caption" color="text.secondary">
                    Proposed
                </Typography>
                <Button
                    variant="text"
                    size="small"
                    onClick={onCancel}
                    sx={{ minWidth: 0, p: 0.25, fontSize: "0.7rem" }}
                >
                    Cancel
                </Button>
                <If truthy={localSaveLabel}>
                    <Button
                        variant="text"
                        size="small"
                        onClick={saveLocal}
                        sx={{ minWidth: 0, p: 0.25, fontSize: "0.7rem" }}
                    >
                        {localSaveLabel}
                    </Button>
                </If>
                <Button
                    variant="text"
                    size="small"
                    onClick={saveShared}
                    sx={{
                        minWidth: 0,
                        p: 0.25,
                        fontSize: "0.7rem",
                        textDecoration: "underline",
                        textUnderlineOffset: 2,
                    }}
                >
                    {sharedSaveLabel}
                </Button>
            </Stack>
            <If truthy={warning}>
                <Alert severity="warning">{warning}</Alert>
            </If>
            <Box sx={{ border: "1px solid", borderColor: "primary.light", borderRadius: 1, overflow: "hidden" }}>
                <Bound target={target}>
                    <BoundTextEditor field="text" label="" />
                </Bound>
            </Box>
        </Stack>
    )

    function saveShared() {
        onSave(target.text, "shared")
    }

    function saveLocal() {
        onSave(target.text, "local")
    }
}
